export interface EDExam {
  uid: number;
  userUID: number; // 사용자 UID
  curriculumUID: number; // EDCurriculum UID
  trialUID: number; // 아직 사용되지 않음
  answers: number[]; // 답안지
  correct: number; // 맞춘 개수
  score: number; // 점수
  note: string; // 비고
  examDate: Date | string; // 응시일

  // NOT DB
  userName: string; // 응시자 이름
  departmentName: string; // 부서명
  trialCount: number; // 응시회수
  isExcluded: boolean; // 제외여부
}

export interface examRankListParam {
  token: string;
  id: number; // 상위 커리쿨럼 UID
  departmentUID?: number;
}
export const initialExamRankListParam: examRankListParam = {
  token: "",
  id: 0,
  departmentUID: -1,
};

export interface excludeExamParam {
  token: string;
  id: number; // EDCurriculum UID
  uid: number; // 제외할 EQUserUID
  note: string; // 비고
}

export const initialExcludeExamParam: excludeExamParam = {
  token: "",
  id: 0,
  uid: 0,
  note: "",
};
export interface includeExamParam {
  token: string;
  id: number; // EDCurriculum UID
  uid: number; // 제외할 EQUserUID
}

export const initialIncludeExamParam: includeExamParam = {
  token: "",
  id: 0,
  uid: 0,
};
